<template>
  <div class="flex items" v-if='media != null'> 
    <div class="media absolute">
      <media ref="media" v-for="(m,i) in media" :active="i==current" :key="i" class="media-player" :content='m'/>
    </div>
    <div class="buttons stretch absolute">
      <div class="holder">
        <div class="btn left" @click="()=> increment(-1)" />
        <div class="btn right" @click="()=> increment(1)"> </div>
      </div>
      <div class="current"> {{current+1}}/{{media.length}} </div>
    </div>
  </div>
</template>
<script>

import Media from '@/components/structure/Media.vue'
export default {
  props: {
    media: Array
  },
  components: {
    Media
  },
  data(){
    return {
      current: 0
    }
  },
  watch: {
    media(){
      this.current=0;
    }
  },
  methods:{
    increment(a){
      this.current = (this.current + a)%this.media.length;
      if(this.current < 0){
        this.current = this.media.length-1;
      }
    },
    stop(){
      this.current = -1;
    },
    start(){
      this.current = 0;
    }
  }

}
</script>

<style scoped>

.items.flex{
  position: relative;
  height: 100%;
}
.media{
  width: 100%;
  position: relative;
  display: block;
  border-width: 0px !important;
  background-color: black;
  padding: 0;
  content:'';
  flex: 1;
}

.holder{
  opacity: 1.0;
}
.holder:hover .btn::after{
  animation: showBtn 0.1s linear;
  animation-fill-mode: forwards;
}


@keyframes showBtn {
  0%{
    background: none;
    opacity: 0.5;
  }
  100%{
    text-shadow: black 1px 1px 2px;
    opacity: 1.0;
  }
}

.buttons{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 5px;
  flex: none;
  top: 0;
  height: 100%;
  align-content: center;
  pointer-events: none;
}

.invisible{
  display: none;
}

.buttons:last-child {
  margin: 0;
}

.btn.left::after{
  content: '\00AB';
}

.btn.left{
  left: 0;
}

.current {
  pointer-events: none;
  font-size: 30px;
  color:white;
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 50px;
  text-align: center;
  text-shadow: black 1px 1px 2px;
}

.btn::after{
  content: '\00BB';
  margin: 0;
  opacity: 0.5;
  display: block;
}

.holder{
  position: absolute;
  height: 60%;
  width: 100%;
}

.btn.right{
  right: 0;
}

.btn{
  cursor:pointer;
  display: flex;
  position: absolute;
  width: 30px;
  font-size: 60px;
  overflow: hidden;
  align-items: center;
  margin-left: 0.2em;
  top:0;
  bottom: 0;
  margin-right: 0.2em;
  color: white;
  pointer-events: all;
  opacity: 0.8;
}

.selected{
  animation: color;
  animation-fill-mode: forwards;
  animation-duration: 0.1s;
}

@keyframes color {
  0% {
    background-color: var(--dark-color);
    transform: scale(1.0,1.0);
  }
  100%{
    background-color: var(--second-color);
    transform: scale(1.5,1.5);
  }
  
}

.media-player{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}


  
</style>
